<template>
    <div class="modal" :class="modalClass" v-show="!hideModal">
        <div class="lds-css ng-scope">
            <div style="width:100%;height:100%" class="lds-eclipse">
                <div :style="{
                    'boxShadow': `0 8px 0 0 ${circleColor}`
                }"></div>
            </div>
            <span>{{modalMessage}}</span>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        hideModal : {
            type : Boolean,
            default : true
        },
        circleColor : {
            type : String,
            default : "#57fdf4"
        },
        modalMessage : {
            type : String,
            default : ''
        },
        modalClass : {
            type : String,
            default : 'lightbox'
        }
    },
    name: 'modal',
}
</script>

<style lang="scss">


.lightbox{
    position: absolute;
    width: 100vw;
    height: 100%;
    background-color: rgba($color: #333, $alpha: .95);
    left: 0;
    top: 0;
    z-index: 9;
}

.modal{
        .lds-css{
            display: flex;
            justify-content: center;
            height: 100%;
            flex-direction: column;
            align-items: center;
            color: #fff;
            text-shadow: 4px 4px 7px #000;
            
            span{
                padding: 10px 0;
            }
        }

        @keyframes lds-eclipse {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    50% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
    }
    @-webkit-keyframes lds-eclipse {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    50% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
    }
    .lds-eclipse {
    position: relative;
    }
    .lds-eclipse div {
    position: absolute;
    -webkit-animation: lds-eclipse 0.5s linear infinite;
    animation: lds-eclipse 0.5s linear infinite;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    // box-shadow: 0 8px 0 0 #57fdf4;
    -webkit-transform-origin: 80px 84px;
    transform-origin: 80px 84px;
    }
    .lds-eclipse {
    width: 50px !important;
    height: 50px !important;
    -webkit-transform: translate(-25px, -25px) scale(0.25) translate(25px, 25px);
    transform: translate(-25px, -25px) scale(0.25) translate(25px, 25px);
    }

}
</style>